import { isNil, filter } from 'lodash';
import { mapState } from 'vuex';

const matrixRowSourcedMixin = {

    props: {
        source: String,
        filter: [String, Object],
    },

    computed: {
        ...mapState({
            rows(state)
            {
                if (isNil(this.filter))
                {
                    return state[this.source];
                }
                return filter(state[this.source], this.filter);
            },
        }),
    },

};

export { matrixRowSourcedMixin }



// WEBPACK FOOTER //
// ./resources/assets/js/components/vue/mixins/matrix-row-sourced-mixin.js